/* @import '../../global/app.css'; */
@import '../../global/min-app.css';

:host {
  @apply selection:text-dark-blue selection:bg-logo-orange font-poppins;
  display: block;
}

/* Text Orientation */
.content-right {
  @apply flex-row-reverse;
}

.content-left {
  @apply flex-row;
}